import axios from "axios";
import { SLACK_CHAT_POST_URL, SLACK_LOGISTICS_PORTAL_URL } from "../../Configs/Slack/config";
import moment from "moment";

export const SlackPostChat = async (postMessage: {provider: string, quantity: number, origin: string}) => {
    const slackData = JSON.stringify(
            {
                "attachments": [
                {
                    "color": "#3CABF0",
                    "blocks": [
                        {
                            "type": "header",
                            "text": {
                                "type": "plain_text",
                                "text": "New Kiddo Band Order has been placed!",
                                "emoji": true
                            }
                        },
                        {
                            "type": "section",
                            "fields": [
                                {
                                    "type": "mrkdwn",
                                    "text": `*Provider:*\n ${postMessage.provider.toUpperCase()}`
                                },
                                {
                                    "type": "mrkdwn",
                                    "text": `*Origin:*\n ${postMessage.origin}`
                                }
                            ]
                        },
                        {
                            "type": "section",
                            "fields": [
                                {
                                    "type": "mrkdwn",
                                    "text": `*When:*\n ${moment(new Date()).format("YYYY-MM-DD hh:mm A")}`
                                },
                                {
                                    "type": "mrkdwn",
                                    "text": `*Quantity:*\n ${postMessage.quantity}`
                                }
                            ]
                        },
                        {
                            "type": "section",
                            "text": {
                                "type": "mrkdwn",
                                "text": `<${SLACK_LOGISTICS_PORTAL_URL}|Visit Logistics Portal>`
                            }
                        }
                    ]
                }
            ]});

    // const body = `channel=${SLACK_CHANNEL_ID}&blocks=${slackData}&token=${SLACK_BOT_TOKEN}`;
    await axios.post(SLACK_CHAT_POST_URL, slackData, {
        withCredentials: false,
    }).then((res: any) => {
        console.log(res)
    }).catch((error: any) => {
        console.log("Slack Error", error.toString());
    });
}